import React, { useEffect, useState } from "react";
import { FaTrash, FaEdit, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import "../Control-panel.css"; // Asegúrate de tener este archivo CSS para los estilos

const ControlProducts = () => {
  const [messageModal, setMessageModal] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [listProducts, setListProducts] = useState([]);

  const [toggleFormProducts, setToggleFormProducts] = useState(false);

  const [insumo, setInsumo] = useState("");
  const [precio_insumo, setPrecioInsumo] = useState(0);

  const [editingProduct, setEditingProduct] = useState(null);
  const [updatedData, setUpdatedData] = useState({});
  const [isUpdating, setIsUpdating] = useState(false);

  const [emptyData, setEmptyData] = useState(false);

  const typeMessages = {
    create: "¡Insumo registrado exitosamente!",
    update: "¡Datos del insumo actualizados exitosamente!",
    delete: "Insumo eliminado exitosamente!",
    error: "Error en el mensaje del modal",
  };

  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    getProducts();
  }, []);

  const openModalSuccess = (type) => {
    switch (type) {
      case "create":
        setMessageModal(typeMessages.create);
        break;
      case "update":
        setMessageModal(typeMessages.update);
        break;
      case "delete":
        setMessageModal(typeMessages.delete);
        break;
      default:
        setMessageModal(typeMessages.error);
        break;
    }
    setIsModalOpen(true);
    setTimeout(() => {
      setIsModalOpen(false);
    }, 3000);
  };

  const cleanFormProducts = () => {
    setInsumo("");
    setPrecioInsumo(0);
  };

  const addInsumo = () => {
    const data = { insumo, precio_insumo };

    if (!insumo || !precio_insumo) {
      setEmptyData(true);
      setTimeout(() => {
        setEmptyData(false);
      }, 3000);
      return;
    }

    fetch(`${API_URL}/create-product`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.result) {
          openModalSuccess("create");
          getProducts();
          setToggleFormProducts(false);
          cleanFormProducts();
        } else {
          alert("No se pudo registrar el nuevo insumo");
        }
      })
      .catch(() => {
        console.log("ERROR CACTH");
      });
  };

  const getProducts = () => {
    fetch(`${API_URL}/products`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.result) {
          setListProducts(result.result);
        } else {
          console.log("No se pudo consultar los insumos");
        }
      });
  };

  const updateProduct = () => {
    if (!isUpdating) return;

    const formattedData = {
      ...updatedData,
    };

    fetch(`${API_URL}/update-product/${editingProduct}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formattedData),
    })
      .then((response) => response.json())
      .then(() => {
        openModalSuccess("update");
        getProducts();
        setEditingProduct(null);
        setIsUpdating(false);
      })
      .catch((error) => console.error("Error al actualizar el insumo:", error));
  };

  const deleteProduct = (productName) => {
    fetch(`${API_URL}/product-delete/${productName}`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.message) {
          openModalSuccess("delete");
          setListProducts(
            listProducts.filter((product) => product.insumo !== productName)
          ); // Elimina visualmente el plan
        } else {
          alert("Error al eliminar el insumo.");
        }
      })
      .catch((error) => console.error("Error al eliminar el insumo:", error));
  };

  const enableEditing = (product) => {
    setEditingProduct(product.insumo);
    setUpdatedData({
      newProduct: product.insumo,
      precio_insumo: product.precio_insumo,
    });
    setIsUpdating(true);
  };

  const handleInputChange = (e, field) => {
    const value = e.target.value;

    setUpdatedData((prev) => {
      const newData = {
        ...prev,
        [field]: value,
      };

      const allFieldsFilled = Object.values(newData).every(
        (val) => String(val || "").trim() !== ""
      );
      setIsUpdating(allFieldsFilled);

      return newData;
    });
  };

  return (
    <div className="container-control-module">
      <div className="table-container">
        <h2>Consulta de insumos</h2>
        <table>
          <thead>
            <tr>
              <th>Tipo de insumo</th>
              <th>Precio</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {listProducts.map((product) => {
              return (
                <tr key={product.insumo}>
                  <td>
                    {editingProduct === product.insumo ? (
                      <input
                        type="text"
                        value={updatedData.newProduct}
                        onChange={(e) => handleInputChange(e, "newProduct")}
                      />
                    ) : (
                      product.insumo
                    )}
                  </td>
                  <td>
                    {editingProduct === product.insumo ? (
                      <input
                        type="number"
                        value={updatedData.precio_insumo}
                        onChange={(e) => handleInputChange(e, "precio_insumo")}
                      />
                    ) : (
                      product.precio_insumo
                    )}
                  </td>
                  <td>
                    <FaEdit
                      className="edit-icon"
                      onClick={() => enableEditing(product)}
                    />
                    <FaTrash
                      className="delete-icon"
                      onClick={() => deleteProduct(product.insumo)}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {/* Formulario */}
      <div className="container-buttons-table">
        <button
          className="btn-add-control-panel"
          onClick={() => setToggleFormProducts(true)}
        >
          + Registrar nuevo insumo
        </button>
        {isUpdating && (
          <button
            className="btn-add-control-panel"
            onClick={updateProduct}
            disabled={!isUpdating}
          >
            Actualizar
          </button>
        )}
      </div>
      {toggleFormProducts && (
        <div className="form-container mb-5">
          <h2>Gestión de insumos</h2>
          <div className="form-group">
            <label htmlFor="name-plan">Nombre del insumo*</label>
            <input
              type="text"
              id="name-insumo"
              value={insumo}
              placeholder="Escribe el nombre del insumo"
              onChange={(e) => {
                setInsumo(e.target.value);
              }}
            />
          </div>
          <div className="form-group">
            <label htmlFor="price-insumo">Precio del insumo*</label>
            <input
              type="number"
              id="price-insumo"
              value={precio_insumo}
              placeholder="Escribe el nombre del insumo"
              onChange={(e) => {
                setPrecioInsumo(e.target.value);
              }}
            />
          </div>
          <div className="add-container">
            <button
              className="btn-add-control-panel mb-4"
              onClick={() => addInsumo()}
            >
              Crear insumo
            </button>
          </div>
        </div>
      )}
      {/* Modal de éxito */}
      {isModalOpen && (
        <div className="modal-success">
          <div className="modal-content">
            <FaCheckCircle size={100} color="green" className="modal-icon" />
            <h1>{messageModal}</h1>
          </div>
        </div>
      )}
      {emptyData && (
      <div className="modal-success">
        <div className="modal-content">
          <FaTimesCircle size={100} color="red" className="modal-icon" />
          <h1>Por favor llenar todos los campos obligatorios(*)</h1>
        </div>
      </div>
      )}
    </div>
  );
};

export default ControlProducts;
